import { render, staticRenderFns } from "./WorkExp.vue?vue&type=template&id=29fd9ae2&"
import script from "./WorkExp.vue?vue&type=script&lang=js&"
export * from "./WorkExp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports